import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';

export class CheckPlaceCommand extends IRequestCommand<
  ICheckPlaceResponse,
  ErrorDetails,
  ICheckPlaceParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  public override setParameters(parameters: ICheckPlaceParameters) {
    this.urlSections.push('places');
    this.urlSections.push('checkPlace');
    this.urlSections.push(parameters.placeId);
    this.composeUrl();
  }
}

export interface ICheckPlaceParameters extends ICommandParameters {
  placeId: string;
}

export interface ICheckPlaceResponse {
  routable: boolean;
  fails: number;
  reasons: string[];
  formattedAddress: string;
  lat: number;
  lng: number;
}
